export const FIRST_PLAY = {
    name: 'FIRST_PLAY',
    code: '167',
    ids: ['167-0', '167-5', '167-10']
};

export const SECOND_PLAY = {
    name: 'SECOND_PLAY',
    code: '167',
    ids: ['167-1', '167-6', '167-11']
};

export const THIRD_PLAY = {
    name: 'THIRD_PLAY',
    code: '167',
    ids: ['167-2', '167-7', '167-12']
};

export const FOURTH_PLAY = {
    name: 'FOURTH_PLAY',
    code: '167',
    ids: ['167-3', '167-8', '167-13']
};

export const FIFTH_PLAY = {
    name: 'FIFTH_PLAY',
    code: '167',
    ids: ['167-4', '167-9', '167-14']
};

export const FIELD_GOAL = {
    name: 'FIELD_GOAL',
    code: '167',
    ids: ['167-15']
};

export const ALL_FIRST_DOWN_MARKETS = [
    FIRST_PLAY,
    SECOND_PLAY,
    THIRD_PLAY,
    FOURTH_PLAY,
    FIFTH_PLAY,
    FIELD_GOAL
];



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/constants/marketTypes.js